export const SECTION_AMADEUS_RATING = 'amadeusRating';
export const SECTION_DESCRIPTION = 'description';
export const SECTION_ATTRIBUTES = 'attributes';
export const SECTION_RATING = 'rating';
export const SECTION_MAP = 'map';
export const REVIEW_SENTIMENT_POSITIVE = 'pos';
export const REVIEW_SENTIMENT_NEUTRAL = 'neu';
export const REVIEW_SENTIMENT_NEGATIVE = 'neg';
export const REVIEW_TREND_POSITIVE = 1;
export const REVIEW_TREND_NEUTRAL = 0;
export const REVIEW_TREND_NEGATIVE = -1;
export const TRAVELLER_TYPE_ALL = 'all';
const TRAVELLER_TYPE_BUSINESS = 'business';
const TRAVELLER_TYPE_COUPLE = 'couple';
const TRAVELLER_TYPE_SOLO = 'solo';
const TRAVELLER_TYPE_FAMILY = 'family';
const TRAVELLER_TYPE_FRIENDS = 'friends';
// http://api.trustyou.com/hotels/documentation.html?key=57b82d5c-98a4-4aeb-9b09-7415425e8300#category-list
export const REVIEW_CATEGORY_ROOM = '11';
export const REVIEW_CATEGORY_LOCATION = '14';
export const REVIEW_CATEGORY_SERVICE = '15';
export const AMADEUSREVIEW_CATEGORY_PRIORITY = ['beach', 'skiArea', 'eatAndDrink', 'family', 'hotel', 'infrastructure', 'location', 'pool', 'room', 'service', 'sport', 'winterSport', 'activities', 'culture', 'wellness'];